const _excluded = ["children", "type", "icon", "muted", "hasIcon"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';
import { Check, Close, Cancel, CheckCircle, RadioButtonUnchecked, WarningFilled } from '../../icons';
import { FORM_TEXT_TYPES } from './constants';
const FORM_TEXT_ICONS = {
  [FORM_TEXT_TYPES.DEFAULT]: null,
  [FORM_TEXT_TYPES.VALID]: Check,
  [FORM_TEXT_TYPES.INVALID]: Close,
  [FORM_TEXT_TYPES.WARNING]: WarningFilled,
  [FORM_TEXT_TYPES.CRITERIA_EMPTY]: RadioButtonUnchecked,
  [FORM_TEXT_TYPES.CRITERIA_VALID]: CheckCircle,
  [FORM_TEXT_TYPES.CRITERIA_INVALID]: Cancel
};
const resolveTextType = _ref => {
  let {
    isInvalid,
    isValid
  } = _ref;
  if (isValid) {
    return FORM_TEXT_TYPES.VALID;
  }
  if (isInvalid) {
    return FORM_TEXT_TYPES.INVALID;
  }
  return FORM_TEXT_TYPES.DEFAULT;
};
function FormTextIcon(_ref2) {
  let {
    type,
    customIcon
  } = _ref2;
  if (customIcon) {
    return customIcon;
  }
  const typeIcon = FORM_TEXT_ICONS[type];
  if (typeIcon) {
    return /*#__PURE__*/React.createElement(Icon, {
      src: typeIcon
    });
  }
  return null;
}
FormTextIcon.propTypes = {
  type: PropTypes.oneOf(Object.values(FORM_TEXT_TYPES)),
  customIcon: PropTypes.node
};
FormTextIcon.defaultProps = {
  type: undefined,
  customIcon: undefined
};
function FormText(_ref3) {
  let {
      children,
      type,
      icon,
      muted,
      hasIcon
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded);
  const className = classNames(props.className, 'pgn__form-text', `pgn__form-text-${type}`, {
    'text-muted': muted
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: className
  }), hasIcon && /*#__PURE__*/React.createElement(FormTextIcon, {
    customIcon: icon,
    type: type
  }), /*#__PURE__*/React.createElement("div", null, children));
}
const FORM_TEXT_TYPE_CHOICES = ['default', 'valid', 'invalid', 'warning', 'criteria-empty', 'criteria-valid', 'criteria-invalid'];
FormText.propTypes = {
  /** Specifies contents of the component. */
  children: PropTypes.node.isRequired,
  /** Specifies class name to append to the base element. */
  className: PropTypes.string,
  /** Specifies whether to show an icon next to the text. */
  hasIcon: PropTypes.bool,
  /** Specifies text type, this affects styling. */
  type: PropTypes.oneOf(FORM_TEXT_TYPE_CHOICES),
  /** Specifies icon to show, will only be shown if `hasIcon` prop is set to `true`. */
  icon: PropTypes.node,
  /** Specifies whether to show text with muted styling. */
  muted: PropTypes.bool
};
FormText.defaultProps = {
  hasIcon: true,
  type: 'default',
  icon: undefined,
  className: undefined,
  muted: false
};
export default FormText;
export { FORM_TEXT_TYPES, FORM_TEXT_ICONS, FormTextIcon, resolveTextType };
//# sourceMappingURL=FormText.js.map